const envVar = {
  REACT_APP_BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  REACT_APP_BASE_ACCESS_TOKEN: process.env.REACT_APP_BASE_ACCESS_TOKEN,
  REACT_APP_EXAM_BASE_URL: process.env.REACT_APP_EXAM_BASE_URL,
  REACT_APP_EXAM_ACCESS_TOKEN: process.env.REACT_APP_EXAM_ACCESS_TOKEN,
  REACT_APP_PAYMENTS_API_BASE_URL: process.env.REACT_APP_PAYMENTS_API_BASE_URL,
  REACT_APP_PAYMENTS_API_TOKEN: process.env.REACT_APP_PAYMENTS_API_TOKEN,
  REACT_APP_ETHER_BASE_URL: process.env.REACT_APP_ETHER_BASE_URL,
  REACT_APP_BUS_TRACKING_API_BASE_URL:
    process.env.REACT_APP_BUS_TRACKING_API_BASE_URL,
  REACT_APP_BUS_TRACKING_API_TOKEN:
    process.env.REACT_APP_BUS_TRACKING_API_TOKEN,
  REACT_APP_S3_BASE_URL: process.env.REACT_APP_S3_BASE_URL
};

export default envVar;
